module.exports = __webpack_public_path__ + "static/media/integral-logo.90638886.png";